/*
* Thème: PERFORMANCE
*/

/*
* Overlay
*/

window.Carousel_Overlay = function() {
  return {
    on: {
      autoplayStop: function(swiper) {
        this.el.querySelector('.carousel__control').innerHTML = '<i class="icon-play-1"></i>';
      },
      init: function(swiper) {
        if (this.el.querySelector('.carousel__control') == null) {
          let pauseButton = document.createElement('button');
          pauseButton.innerHTML = '<i class="icon-pause"></i>';
          pauseButton.classList.add('carousel__control');
          this.el.querySelector('.carousel__toolbar').appendChild(pauseButton);

          let isPaused = false;
          pauseButton.addEventListener('click', () => {
            if (this.el.querySelector('.icon-pause') == null) {
                swiper.autoplay.start();
                pauseButton.innerHTML = '<i class="icon-pause"></i>';
            } else {
                swiper.autoplay.stop();
                pauseButton.innerHTML = '<i class="icon-play-1"></i>';
            }
            isPaused = !isPaused;
          });
        }
      },
    },
  }
}

/* End: PERFORMANCE */
